import React from "react";
import {
  ShowView,
  ShowController,
  Tab,
  TabbedShowLayout,
  SimpleShowLayout,
  TextField,
  ReferenceManyField,
  Pagination,
  Datagrid
} from "react-admin";
import FootballTab from "./FootballTab";
import GirlsVolleyballTab from "./GirlsVolleyballTab";
import BasketballTab from "./BasketballTab";
import SoccerTab from "./SoccerTab";
import BaseballTab from "./BaseballTab";
import { CustomGameStatusField } from "../fields/CustomGamesStatusField";

const PlayerShow = (props) => {
  return (
    <ShowController {...props}>
      {(controllerProps) => (
        <ShowView {...props} {...controllerProps}>
          <TabbedShowLayout>
            <Tab label="summary">
              <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="person.name" />
                <TextField source="team.team.name" />
                <TextField source="jerseyNumber" />
                <TextField source="position" />
                <TextField source="additionalPositions" />
                <TextField source="yearCode" />
                <TextField source="isActive" />
              </SimpleShowLayout>
            </Tab>
            {controllerProps.record &&
              controllerProps.record.sportCode === "football" && (
                <Tab label="football">
                  <FootballTab />
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "girls-volleyball" && (
                <Tab label="volleyball">
                  <GirlsVolleyballTab />
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "girls-basketball" && (
                <Tab label="girls-basketball">
                  <BasketballTab />
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "boys-basketball" && (
                <Tab label="boys-basketball">
                  <BasketballTab />
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "girls-soccer" && (
                <Tab label="girls-soccer">
                  <SoccerTab />
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "boys-soccer" && (
                <Tab label="boys-soccer">
                  <SoccerTab />
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "softball" && (
                <Tab label="softball">
                  <BaseballTab />
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "baseball" && (
                <Tab label="baseball">
                  <BaseballTab />
                </Tab>
              )}
            <Tab label="games">
              <SimpleShowLayout>
                <ReferenceManyField
                  reference="gamePlayers"
                  target="school_sport_season_team_id"
                  addLabel={false}
                  pagination={<Pagination />}
                  fullWidth
                >
                  <Datagrid rowClick="show">
                    <TextField source="teamGame.game.id" />
                    <TextField label="sport" source="sportCode" />
                    <TextField
                      label="season"
                      source="teamGame.game.seasonCode"
                    />
                    <TextField
                      label="date"
                      source="teamGame.game.gameDateString"
                    />
                    <TextField
                      label="home"
                      source="teamGame.game.home.season.team.school.name"
                    />
                    <TextField
                      label="away"
                      source="teamGame.game.away.season.team.school.name"
                    />
                    <CustomGameStatusField
                      source="gameStatus"
                      label="Is Final"
                    />
                  </Datagrid>
                </ReferenceManyField>
              </SimpleShowLayout>
            </Tab>
          </TabbedShowLayout>
        </ShowView>
      )}
    </ShowController>
  );
};

export default PlayerShow;
